import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { PRESCRIPTION_STATUS } from 'src/app/helpers/prescription-status.helper';
import { CartItemsTotal } from 'src/app/models/cart-items-total.model';
import { CartItems } from 'src/app/models/cart-items.model';
import { Modules } from 'src/app/models/modules.model';
import { Prescription } from 'src/app/models/prescription.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { ModulesService } from 'src/app/services/repositories/modules.service';
import { PrescriptionService } from 'src/app/services/repositories/prescription.service';
@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false
})
export class CartComponent implements OnInit {
  toggleClass: boolean = true;
  cartItemsTotal: CartItemsTotal | undefined;
  cartItems: CartItems[] = [];
  orderCategories = ORDER_CATEGORY;
  prescriptionStatusText: string = '';
  ediText: string = ''
  canCheckout: boolean = false;
  modules: Modules[] = [];

  constructor(private _notificationService: ToastrService,
              private _cartManagerService: CartManagerService,
              private _modulesService: ModulesService,
              private _prescriptionService: PrescriptionService) { }

  ngOnInit() {
    this.getCartItems();
    this.loadModules();
    this.prescriptionStatusText = PRESCRIPTION_STATUS.NO_PRESCRIPTION;
    this.checkRx();
  }

  getCartItems() {
    this._cartManagerService.getCart()
    .subscribe((cartItems: CartItemsTotal) => {
      this.cartItemsTotal = cartItems;
      this.prescriptionStatusText = PRESCRIPTION_STATUS.NO_PRESCRIPTION;
      this.checkCart();
      this.checkRx();
    });
  }

  checkCart() {
    if (this.cartItemsTotal) {
      this.canCheckout = true;
    }
    else {
      this.canCheckout = false;
    }
  }

  removeCartItem(itemId: number) {
    this._cartManagerService.removeCartItem(itemId)
    .subscribe(() => {
      this.getCartItems();
    }, (error: any) => {
      this._notificationService.error('', '')
    });

  }

  checkRx() {
    this._prescriptionService.getRx()
      .subscribe((data: Prescription) => {
        if (data) {
          const prescription = data;
          if (prescription.isValid) {
            this.prescriptionStatusText = PRESCRIPTION_STATUS.ON_FILE;
          }
          else {
            this.prescriptionStatusText = PRESCRIPTION_STATUS.NO_PRESCRIPTION;
          }
        }
      }, (error: any) => {
        this.prescriptionStatusText = PRESCRIPTION_STATUS.NO_PRESCRIPTION;
      });
  }

  loadModules() {
    this._modulesService.getModules()
      .subscribe((data: Modules[]) => {
        this.modules = data;
      }, (error) => {
        console.log(error);
      });
  }

}
